const HTML_TAG_PATTERN = /<\/?[a-z][a-z0-9]*\b[^>]*\/?>/gi;

// The model ends replies with a hidden "§FOLLOWUPS§ q1 | q2 | q3" line that the backend turns into
// follow-up suggestion chips. Strip it (and any partial version still streaming) from the bubble.
const FOLLOWUPS_COMPLETE_PATTERN = /§FOLLOWUPS§[\s\S]*$/;
const FOLLOWUPS_PARTIAL_PATTERN = /\n*§F?O?L?L?O?W?U?P?S?§?\s*$/;

/**
 * Strips raw HTML tags from LLM-generated markdown so ReactMarkdown
 * doesn't render them as literal text.
 * Block-level tags (br, hr, div, p) are replaced with double newlines;
 * inline tags (span, b, i, em, strong, etc.) are removed silently.
 */
export function sanitizeMarkdown(text: string): string {
  const withoutFollowups = text
    .replace(FOLLOWUPS_COMPLETE_PATTERN, '')
    .replace(FOLLOWUPS_PARTIAL_PATTERN, '');
  return withoutFollowups
    .replace(HTML_TAG_PATTERN, (match) => {
      const tagName = match.replace(/<\/?([a-z][a-z0-9]*)\b.*/i, '$1').toLowerCase();
      const isBlock = BLOCK_TAGS.has(tagName);
      return isBlock ? '\n\n' : '';
    })
    .trimEnd();
}

const BLOCK_TAGS = new Set(['br', 'hr', 'div', 'p', 'section', 'article', 'header', 'footer', 'nav', 'aside']);
